var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIran(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.17 31.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#da0000;}.cls-2{fill:#fff;}.cls-3{fill:#239f40;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Iran") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.73,22.64v-.49h-.8v.52h-.18V22H46.9v.49h.27v-.81H45.72v-.17h1.45v-.44H45.72V21h-.25v.09h-2.2V21H43v.09h-2.2V21h-.25v.09h-2.2V21h-.25v.09h-2.2V21h-.24v.09h-2.2V21h-.25v.09H31V21H30.8v.09H28.6V21h-.25v.09h-2.2V21h-.24v.09h-2.2V21h-.25v.09h-2.2V21H21v.09H18.81V21h-.24v.09h-2.2V21h-.25v.09h-2.2V21h-.24v.09h-2.2V21h-.25v.09H9V21H8.79v.09H6.59V21H6.34v.09H4.14V21H3.9v.09H1.69V21H1.45v.09H0V22H.26v-.53H.44v1H.75v-1H.93v1h.31v-1h.17v1.19H.26v-.49H0v9.29H47.17v-8.8Zm-45-1.15H4.87v.17H1.69Zm.74,1.15H2.18v-.17h.25Zm1.43,0H2.71v-.49H1.9v.52H1.73V22H2.88v.49h.81v-.32H3.16V22h.7Zm2.45,0H5.15v-.49h-.8v.32h.52v.17H4.18V22h1v-.53h.18v1h.31v-1h.18v1h.31v-1h.18Zm.28-1.15H9.77v.17H6.59Zm.73,1.15H7.07v-.17h.25Zm1.43,0H7.6v-.49H6.8v.52H6.62V22H7.77v.49h.81v-.32H8.05V22h.7Zm2.45,0H10v-.49h-.8v.32h.53v.17h-.7V22h1v-.53h.18v1h.31v-1h.18v1H11v-1h.18Zm.28-1.15h3.18v.17H11.48Zm.73,1.15H12v-.17h.24Zm1.43,0H12.49v-.49h-.8v.52h-.18V22h1.16v.49h.8v-.32h-.53V22h.7Zm2.45,0H14.94v-.49h-.81v.32h.53v.17H14V22h1v-.53h.17v1h.32v-1h.17v1h.31v-1h.18Zm.28-1.15h3.18v.17H16.37Zm.73,1.15h-.24v-.17h.24Zm1.43,0H17.38v-.49h-.8v.52H16.4V22h1.16v.49h.8v-.32h-.52V22h.69Zm2.45,0H19.83v-.49H19v.32h.53v.17h-.7V22h1v-.53H20v1h.32v-1h.17v1h.32v-1H21Zm.28-1.15h3.18v.17H21.26ZM22,22.64h-.24v-.17H22Zm1.44,0H22.27v-.49h-.8v.52h-.18V22h1.16v.49h.8v-.32h-.52V22h.7Zm2.44,0H24.72v-.49h-.8v.32h.52v.17h-.7V22h1v-.53h.17v1h.32v-1h.17v1h.32v-1h.17Zm.28-1.15h3.18v.17H26.15Zm.73,1.15h-.24v-.17h.24Zm1.44,0H27.16v-.49h-.8v.52h-.17V22h1.15v.49h.8v-.32h-.52V22h.7Zm2.44,0H29.61v-.49h-.8v.32h.52v.17h-.7V22h1v-.53h.17v1h.32v-1h.17v1h.32v-1h.17ZM31,21.49h3.18v.17H31Zm.74,1.15h-.25v-.17h.25Zm1.43,0H32.06v-.49h-.81v.52h-.17V22h1.15v.49H33v-.32h-.52V22h.7Zm2.44,0H34.5v-.49h-.8v.32h.52v.17h-.7V22h1v-.53h.18v1H35v-1h.18v1h.31v-1h.17Zm.28-1.15h3.18v.17H35.93Zm.74,1.15h-.25v-.17h.25Zm1.43,0H37v-.49h-.81v.52H36V22h1.15v.49h.81v-.32H37.4V22h.7Zm2.45,0H39.39v-.49h-.8v.32h.52v.17h-.7V22h1v-.53h.18v1h.31v-1h.18v1h.31v-1h.18Zm.28-1.15H44v.17H40.83Zm.73,1.15h-.25v-.17h.25Zm1.43,0H41.84v-.49H41v.52h-.17V22H42v.49h.81v-.32h-.53V22H43Zm2.45,0H44.28v-.49h-.8v.32H44v.17h-.69V22h1v-.53h.18v1h.31v-1H45v1h.31v-1h.18Zm1,0h-.24v-.17h.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.45,21h.24v-.08H3.9V21h.24v-.08h2.2V21h.25v-.08h2.2V21H9v-.08h2.2V21h.25v-.08h2.2V21h.24v-.08h2.2V21h.25v-.08h2.2V21h.24v-.08H21V21h.24v-.08h2.2V21h.25v-.08h2.2V21h.24v-.08h2.2V21h.25v-.08h2.2V21H31v-.08h2.2V21h.25v-.08h2.2V21h.24v-.08h2.2V21h.25v-.08h2.2V21h.25v-.08H43V21h.24v-.08h2.2V21h.25v-.08h1.45V10.57H45.72v-.09h-.25v.09h-2.2v-.09H43v.09h-2.2v-.09h-.25v.09h-2.2v-.09h-.25v.09h-2.2v-.09h-.24v.09h-2.2v-.09h-.25v.09H31v-.09H30.8v.09H28.6v-.09h-.25v.09h-2.2v-.09h-.24v.09h-2.2v-.09h-.25v.09h-2.2v-.09H21v.09H18.81v-.09h-.24v.09h-2.2v-.09h-.25v.09h-2.2v-.09h-.24v.09h-2.2v-.09h-.25v.09H9v-.09H8.79v.09H6.59v-.09H6.34v.09H4.14v-.09H3.9v.09H1.69v-.09H1.45v.09H0V20.88H1.45Zm25.66-6.74a3,3,0,0,1-1.1,4.1h0a3.93,3.93,0,0,0-.78-5.5A3,3,0,0,1,27.11,14.22Zm-4.52-2.3a.55.55,0,0,0,.63.43.54.54,0,0,0,.36-.26.56.56,0,0,0,.37.26.53.53,0,0,0,.62-.43.55.55,0,0,1-.2.67.57.57,0,0,1-.79-.13.57.57,0,0,1-.79.13A.58.58,0,0,1,22.59,11.92Zm-.3,1a3.93,3.93,0,0,0,.95,5.38l-.12-2.93V13a1.33,1.33,0,0,0,.46-.39,1.28,1.28,0,0,0,.47.39v2.31l-.12,2.93a3.93,3.93,0,0,0,.94-5.38,3.58,3.58,0,0,1-.67,5.9,4.21,4.21,0,0,0,1.54.23,3.65,3.65,0,0,1-1.85.1v.12l-.31.42-.3-.42v-.12a3.62,3.62,0,0,1-1.84-.1A4.21,4.21,0,0,0,23,18.78a3.59,3.59,0,0,1-.68-5.9Zm-2.23,1.34a3,3,0,0,1,1.87-1.41,3.92,3.92,0,0,0-.78,5.5h0A3,3,0,0,1,20.06,14.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.45,10.48h.24v-.09H3.9v.09h.24v-.09h2.2v.09h.25v-.09h2.2v.09H9v-.09h2.2v.09h.25v-.09h2.2v.09h.24v-.09h2.2v.09h.25v-.09h2.2v.09h.24v-.09H21v.09h.24v-.09h2.2v.09h.25v-.09h2.2v.09h.24v-.09h2.2v.09h.25v-.09h2.2v.09H31v-.09h2.2v.09h.25v-.09h2.2v.09h.24v-.09h2.2v.09h.25v-.09h2.2v.09h.25v-.09H43v.09h.24v-.09h2.2v.09h.25v-.09h1.45V10h-.44V9.47h-.8V10h-.18v-.7H46.9v.49h.27V9H45.72V8.8h1.45V0H0V9.29H.26V8.77H.44v1H.75v-1H.93v1h.31v-1h.17V10H.26V9.47H0v.92H1.45Zm44.76-.7h.24V10h-.24ZM41.56,10h-.25V9.78h.25ZM43,10H41.84V9.47H41V10h-.17v-.7H42v.49h.81V9.47h-.53V9.29H43Zm1.29-1.19h.18v1h.31v-1H45v1h.31v-1h.18V10H44.28V9.47h-.8v.31H44V10h-.69V9.29h1Zm-3.45,0H44V9H40.83ZM36.67,10h-.25V9.78h.25Zm1.43,0H37V9.47h-.81V10H36v-.7h1.15v.49h.81V9.47H37.4V9.29h.7Zm1.29-1.19h.18v1h.31v-1h.18v1h.31v-1h.18V10H39.39V9.47h-.8v.31h.52V10h-.7V9.29h1Zm-3.46,0h3.18V9H35.93ZM31.78,10h-.25V9.78h.25Zm1.43,0H32.06V9.47h-.81V10h-.17v-.7h1.15v.49H33V9.47h-.52V9.29h.7ZM34.5,8.77h.18v1H35v-1h.18v1h.31v-1h.17V10H34.5V9.47h-.8v.31h.52V10h-.7V9.29h1ZM31,8.8h3.18V9H31ZM26.88,10h-.24V9.78h.24Zm1.44,0H27.16V9.47h-.8V10h-.17v-.7h1.15v.49h.8V9.47h-.52V9.29h.7Zm1.29-1.19h.17v1h.32v-1h.17v1h.32v-1h.17V10H29.61V9.47h-.8v.31h.52V10h-.7V9.29h1Zm-3.46,0h3.18V9H26.15ZM22,10h-.24V9.78H22Zm1.44,0H22.27V9.47h-.8V10h-.18v-.7h1.16v.49h.8V9.47h-.52V9.29h.7Zm1.29-1.19h.17v1h.32v-1h.17v1h.32v-1h.17V10H24.72V9.47h-.8v.31h.52V10h-.7V9.29h1Zm-3.46,0h3.18V9H21.26ZM17.1,10h-.24V9.78h.24Zm1.43,0H17.38V9.47h-.8V10H16.4v-.7h1.16v.49h.8V9.47h-.52V9.29h.69Zm1.3-1.19H20v1h.32v-1h.17v1h.32v-1H21V10H19.83V9.47H19v.31h.53V10h-.7V9.29h1Zm-3.46,0h3.18V9H16.37ZM12.21,10H12V9.78h.24Zm1.43,0H12.49V9.47h-.8V10h-.18v-.7h1.16v.49h.8V9.47h-.53V9.29h.7Zm1.3-1.19h.17v1h.32v-1h.17v1h.31v-1h.18V10H14.94V9.47h-.81v.31h.53V10H14V9.29h1Zm-3.46,0h3.18V9H11.48ZM7.32,10H7.07V9.78h.25Zm1.43,0H7.6V9.47H6.8V10H6.62v-.7H7.77v.49h.81V9.47H8.05V9.29h.7ZM10,8.77h.18v1h.31v-1h.18v1H11v-1h.18V10H10V9.47h-.8v.31h.53V10h-.7V9.29h1Zm-3.45,0H9.77V9H6.59ZM2.43,10H2.18V9.78h.25Zm1.43,0H2.71V9.47H1.9V10H1.73v-.7H2.88v.49h.81V9.47H3.16V9.29h.7ZM5.15,8.77h.18v1h.31v-1h.18v1h.31v-1h.18V10H5.15V9.47h-.8v.31h.52V10H4.18V9.29h1Zm-3.46,0H4.87V9H1.69Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.26 9.96 1.42 9.96 1.42 8.77 1.24 8.77 1.24 9.78 0.93 9.78 0.93 8.77 0.75 8.77 0.75 9.78 0.44 9.78 0.44 8.77 0.26 8.77 0.26 9.29 0 9.29 0 9.47 0.26 9.47 0.26 9.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1.45 10.48 1.45 10.39 0 10.39 0 10.57 1.45 10.57 1.45 10.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1.45 20.96 1.45 20.88 0 20.88 0 21.05 1.45 21.05 1.45 20.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0.26 22.64 1.42 22.64 1.42 21.45 1.24 21.45 1.24 22.46 0.93 22.46 0.93 21.45 0.75 21.45 0.75 22.46 0.44 22.46 0.44 21.45 0.26 21.45 0.26 21.98 0 21.98 0 22.15 0.26 22.15 0.26 22.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.18,
    y: 9.78,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.16 9.47 3.69 9.47 3.69 9.78 2.88 9.78 2.88 9.29 1.73 9.29 1.73 9.99 1.9 9.99 1.9 9.47 2.71 9.47 2.71 9.96 3.86 9.96 3.86 9.29 3.16 9.29 3.16 9.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.17 9.96 4.87 9.96 4.87 9.78 4.35 9.78 4.35 9.47 5.15 9.47 5.15 9.96 6.31 9.96 6.31 8.77 6.13 8.77 6.13 9.78 5.82 9.78 5.82 8.77 5.64 8.77 5.64 9.78 5.33 9.78 5.33 8.77 5.15 8.77 5.15 9.29 4.17 9.29 4.17 9.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.69,
    y: 8.8,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1.7 10.39 1.7 10.48 1.7 10.57 3.9 10.57 3.9 10.48 3.9 10.39 1.7 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.14 10.39 4.14 10.48 4.14 10.57 6.34 10.57 6.34 10.48 6.34 10.39 4.14 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4.14 20.88 4.14 20.96 4.14 21.05 6.34 21.05 6.34 20.96 6.34 20.88 4.14 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1.7 20.88 1.7 20.96 1.7 21.05 3.9 21.05 3.9 20.96 3.9 20.88 1.7 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3.16 22.15 3.69 22.15 3.69 22.46 2.88 22.46 2.88 21.98 1.73 21.98 1.73 22.68 1.9 22.68 1.9 22.15 2.71 22.15 2.71 22.64 3.86 22.64 3.86 21.98 3.16 21.98 3.16 22.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 1.69,
    y: 21.49,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.18,
    y: 22.47,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.13 22.46 5.82 22.46 5.82 21.45 5.64 21.45 5.64 22.46 5.33 22.46 5.33 21.45 5.15 21.45 5.15 21.98 4.17 21.98 4.17 22.64 4.87 22.64 4.87 22.46 4.35 22.46 4.35 22.15 5.15 22.15 5.15 22.64 6.31 22.64 6.31 21.45 6.13 21.45 6.13 22.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.05 9.47 8.58 9.47 8.58 9.78 7.77 9.78 7.77 9.29 6.62 9.29 6.62 9.99 6.79 9.99 6.79 9.47 7.6 9.47 7.6 9.96 8.75 9.96 8.75 9.29 8.05 9.29 8.05 9.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.07,
    y: 9.78,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.07 9.96 9.77 9.96 9.77 9.78 9.24 9.78 9.24 9.47 10.04 9.47 10.04 9.96 11.2 9.96 11.2 8.77 11.02 8.77 11.02 9.78 10.71 9.78 10.71 8.77 10.53 8.77 10.53 9.78 10.22 9.78 10.22 8.77 10.04 8.77 10.04 9.29 9.07 9.29 9.07 9.96"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.59,
    y: 8.8,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.59 10.39 6.59 10.48 6.59 10.57 8.79 10.57 8.79 10.48 8.79 10.39 6.59 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.03 10.39 9.03 10.48 9.03 10.57 11.23 10.57 11.23 10.48 11.23 10.39 9.03 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.59 20.88 6.59 20.96 6.59 21.05 8.79 21.05 8.79 20.96 8.79 20.88 6.59 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.03 20.88 9.03 20.96 9.03 21.05 11.23 21.05 11.23 20.96 11.23 20.88 9.03 20.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.59,
    y: 21.49,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "8.05 22.15 8.58 22.15 8.58 22.46 7.77 22.46 7.77 21.98 6.62 21.98 6.62 22.68 6.79 22.68 6.79 22.15 7.6 22.15 7.6 22.64 8.75 22.64 8.75 21.98 8.05 21.98 8.05 22.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.02 22.46 10.71 22.46 10.71 21.45 10.53 21.45 10.53 22.46 10.22 22.46 10.22 21.45 10.04 21.45 10.04 21.98 9.07 21.98 9.07 22.64 9.77 22.64 9.77 22.46 9.24 22.46 9.24 22.15 10.04 22.15 10.04 22.64 11.2 22.64 11.2 21.45 11.02 21.45 11.02 22.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 7.07,
    y: 22.47,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.96 9.96 14.66 9.96 14.66 9.78 14.13 9.78 14.13 9.47 14.94 9.47 14.94 9.96 16.09 9.96 16.09 8.77 15.91 8.77 15.91 9.78 15.6 9.78 15.6 8.77 15.43 8.77 15.43 9.78 15.11 9.78 15.11 8.77 14.94 8.77 14.94 9.29 13.96 9.29 13.96 9.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.95 9.47 13.47 9.47 13.47 9.78 12.66 9.78 12.66 9.29 11.51 9.29 11.51 9.99 11.69 9.99 11.69 9.47 12.49 9.47 12.49 9.96 13.64 9.96 13.64 9.29 12.95 9.29 12.95 9.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.97,
    y: 9.78,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.48,
    y: 8.8,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.48 10.39 11.48 10.48 11.48 10.57 13.68 10.57 13.68 10.48 13.68 10.39 11.48 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.92 10.39 13.92 10.48 13.92 10.57 16.12 10.57 16.12 10.48 16.12 10.39 13.92 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "11.48 20.88 11.48 20.96 11.48 21.05 13.68 21.05 13.68 20.96 13.68 20.88 11.48 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.92 20.88 13.92 20.96 13.92 21.05 16.12 21.05 16.12 20.96 16.12 20.88 13.92 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "15.91 22.46 15.6 22.46 15.6 21.45 15.43 21.45 15.43 22.46 15.11 22.46 15.11 21.45 14.94 21.45 14.94 21.98 13.96 21.98 13.96 22.64 14.66 22.64 14.66 22.46 14.13 22.46 14.13 22.15 14.94 22.15 14.94 22.64 16.09 22.64 16.09 21.45 15.91 21.45 15.91 22.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.48,
    y: 21.49,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 11.97,
    y: 22.47,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "12.95 22.15 13.47 22.15 13.47 22.46 12.66 22.46 12.66 21.98 11.51 21.98 11.51 22.68 11.69 22.68 11.69 22.15 12.49 22.15 12.49 22.64 13.64 22.64 13.64 21.98 12.95 21.98 12.95 22.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.85 9.96 19.55 9.96 19.55 9.78 19.02 9.78 19.02 9.47 19.83 9.47 19.83 9.96 20.98 9.96 20.98 8.77 20.81 8.77 20.81 9.78 20.49 9.78 20.49 8.77 20.32 8.77 20.32 9.78 20 9.78 20 8.77 19.83 8.77 19.83 9.29 18.85 9.29 18.85 9.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.84 9.47 18.36 9.47 18.36 9.78 17.56 9.78 17.56 9.29 16.4 9.29 16.4 9.99 16.58 9.99 16.58 9.47 17.38 9.47 17.38 9.96 18.54 9.96 18.54 9.29 17.84 9.29 17.84 9.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.86,
    y: 9.78,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.37,
    y: 8.8,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.81 10.39 18.81 10.48 18.81 10.57 21.02 10.57 21.02 10.48 21.02 10.39 18.81 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "16.37 10.39 16.37 10.48 16.37 10.57 18.57 10.57 18.57 10.48 18.57 10.39 16.37 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "16.37 20.88 16.37 20.96 16.37 21.05 18.57 21.05 18.57 20.96 18.57 20.88 16.37 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.81 20.88 18.81 20.96 18.81 21.05 21.02 21.05 21.02 20.96 21.02 20.88 18.81 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.81 22.46 20.49 22.46 20.49 21.45 20.32 21.45 20.32 22.46 20 22.46 20 21.45 19.83 21.45 19.83 21.98 18.85 21.98 18.85 22.64 19.55 22.64 19.55 22.46 19.02 22.46 19.02 22.15 19.83 22.15 19.83 22.64 20.98 22.64 20.98 21.45 20.81 21.45 20.81 22.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.84 22.15 18.36 22.15 18.36 22.46 17.56 22.46 17.56 21.98 16.4 21.98 16.4 22.68 16.58 22.68 16.58 22.15 17.38 22.15 17.38 22.64 18.54 22.64 18.54 21.98 17.84 21.98 17.84 22.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.86,
    y: 22.47,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 16.37,
    y: 21.49,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.75,
    y: 9.78,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.74 9.96 24.44 9.96 24.44 9.78 23.91 9.78 23.91 9.47 24.72 9.47 24.72 9.96 25.87 9.96 25.87 8.77 25.7 8.77 25.7 9.78 25.38 9.78 25.38 8.77 25.21 8.77 25.21 9.78 24.89 9.78 24.89 8.77 24.72 8.77 24.72 9.29 23.74 9.29 23.74 9.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22.73 9.47 23.25 9.47 23.25 9.78 22.45 9.78 22.45 9.29 21.3 9.29 21.3 9.99 21.47 9.99 21.47 9.47 22.27 9.47 22.27 9.96 23.43 9.96 23.43 9.29 22.73 9.29 22.73 9.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.26,
    y: 8.8,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.26 10.39 21.26 10.48 21.26 10.57 23.46 10.57 23.46 10.48 23.46 10.39 21.26 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.71 10.39 23.71 10.48 23.71 10.57 25.91 10.57 25.91 10.48 25.91 10.39 23.71 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "23.71 20.88 23.71 20.96 23.71 21.05 25.91 21.05 25.91 20.96 25.91 20.88 23.71 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.26 20.88 21.26 20.96 21.26 21.05 23.46 21.05 23.46 20.96 23.46 20.88 21.26 20.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.26,
    y: 21.49,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "22.73 22.15 23.25 22.15 23.25 22.46 22.45 22.46 22.45 21.98 21.3 21.98 21.3 22.68 21.47 22.68 21.47 22.15 22.27 22.15 22.27 22.64 23.43 22.64 23.43 21.98 22.73 21.98 22.73 22.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "25.7 22.46 25.38 22.46 25.38 21.45 25.21 21.45 25.21 22.46 24.89 22.46 24.89 21.45 24.72 21.45 24.72 21.98 23.74 21.98 23.74 22.64 24.44 22.64 24.44 22.46 23.91 22.46 23.91 22.15 24.72 22.15 24.72 22.64 25.87 22.64 25.87 21.45 25.7 21.45 25.7 22.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21.75,
    y: 22.47,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.15,
    y: 8.8,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.64,
    y: 9.78,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.63 9.96 29.33 9.96 29.33 9.78 28.81 9.78 28.81 9.47 29.61 9.47 29.61 9.96 30.76 9.96 30.76 8.77 30.59 8.77 30.59 9.78 30.27 9.78 30.27 8.77 30.1 8.77 30.1 9.78 29.79 9.78 29.79 8.77 29.61 8.77 29.61 9.29 28.63 9.29 28.63 9.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.62 9.47 28.14 9.47 28.14 9.78 27.34 9.78 27.34 9.29 26.19 9.29 26.19 9.99 26.36 9.99 26.36 9.47 27.16 9.47 27.16 9.96 28.32 9.96 28.32 9.29 27.62 9.29 27.62 9.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.6 10.39 28.6 10.48 28.6 10.57 30.8 10.57 30.8 10.48 30.8 10.39 28.6 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.15 10.39 26.15 10.48 26.15 10.57 28.35 10.57 28.35 10.48 28.35 10.39 26.15 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.15 20.88 26.15 20.96 26.15 21.05 28.35 21.05 28.35 20.96 28.35 20.88 26.15 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "28.6 20.88 28.6 20.96 28.6 21.05 30.8 21.05 30.8 20.96 30.8 20.88 28.6 20.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.64,
    y: 22.47,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "27.62 22.15 28.14 22.15 28.14 22.46 27.34 22.46 27.34 21.98 26.19 21.98 26.19 22.68 26.36 22.68 26.36 22.15 27.16 22.15 27.16 22.64 28.32 22.64 28.32 21.98 27.62 21.98 27.62 22.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 26.15,
    y: 21.49,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "30.59 22.46 30.27 22.46 30.27 21.45 30.1 21.45 30.1 22.46 29.79 22.46 29.79 21.45 29.61 21.45 29.61 21.98 28.63 21.98 28.63 22.64 29.33 22.64 29.33 22.46 28.81 22.46 28.81 22.15 29.61 22.15 29.61 22.64 30.76 22.64 30.76 21.45 30.59 21.45 30.59 22.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.04,
    y: 8.8,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.53,
    y: 9.78,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.52 9.96 34.22 9.96 34.22 9.78 33.7 9.78 33.7 9.47 34.5 9.47 34.5 9.96 35.65 9.96 35.65 8.77 35.48 8.77 35.48 9.78 35.16 9.78 35.16 8.77 34.99 8.77 34.99 9.78 34.68 9.78 34.68 8.77 34.5 8.77 34.5 9.29 33.52 9.29 33.52 9.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.51 9.47 33.03 9.47 33.03 9.78 32.23 9.78 32.23 9.29 31.08 9.29 31.08 9.99 31.25 9.99 31.25 9.47 32.06 9.47 32.06 9.96 33.21 9.96 33.21 9.29 32.51 9.29 32.51 9.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.49 10.39 33.49 10.48 33.49 10.57 35.69 10.57 35.69 10.48 35.69 10.39 33.49 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.04 10.39 31.04 10.48 31.04 10.57 33.24 10.57 33.24 10.48 33.24 10.39 31.04 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.49 20.88 33.49 20.96 33.49 21.05 35.69 21.05 35.69 20.96 35.69 20.88 33.49 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.04 20.88 31.04 20.96 31.04 21.05 33.24 21.05 33.24 20.96 33.24 20.88 31.04 20.88"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.53,
    y: 22.47,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 31.04,
    y: 21.49,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "32.51 22.15 33.03 22.15 33.03 22.46 32.23 22.46 32.23 21.98 31.08 21.98 31.08 22.68 31.25 22.68 31.25 22.15 32.06 22.15 32.06 22.64 33.21 22.64 33.21 21.98 32.51 21.98 32.51 22.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.48 22.46 35.16 22.46 35.16 21.45 34.99 21.45 34.99 22.46 34.68 22.46 34.68 21.45 34.5 21.45 34.5 21.98 33.52 21.98 33.52 22.64 34.22 22.64 34.22 22.46 33.7 22.46 33.7 22.15 34.5 22.15 34.5 22.64 35.65 22.64 35.65 21.45 35.48 21.45 35.48 22.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.42,
    y: 9.78,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.4 9.47 37.92 9.47 37.92 9.78 37.12 9.78 37.12 9.29 35.97 9.29 35.97 9.99 36.14 9.99 36.14 9.47 36.95 9.47 36.95 9.96 38.1 9.96 38.1 9.29 37.4 9.29 37.4 9.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.93,
    y: 8.8,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.41 9.96 39.11 9.96 39.11 9.78 38.59 9.78 38.59 9.47 39.39 9.47 39.39 9.96 40.55 9.96 40.55 8.77 40.37 8.77 40.37 9.78 40.06 9.78 40.06 8.77 39.88 8.77 39.88 9.78 39.57 9.78 39.57 8.77 39.39 8.77 39.39 9.29 38.41 9.29 38.41 9.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.38 10.39 38.38 10.48 38.38 10.57 40.58 10.57 40.58 10.48 40.58 10.39 38.38 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.93 10.39 35.93 10.48 35.93 10.57 38.13 10.57 38.13 10.48 38.13 10.39 35.93 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.38 20.88 38.38 20.96 38.38 21.05 40.58 21.05 40.58 20.96 40.58 20.88 38.38 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "35.93 20.88 35.93 20.96 35.93 21.05 38.13 21.05 38.13 20.96 38.13 20.88 35.93 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "37.4 22.15 37.92 22.15 37.92 22.46 37.12 22.46 37.12 21.98 35.97 21.98 35.97 22.68 36.14 22.68 36.14 22.15 36.95 22.15 36.95 22.64 38.1 22.64 38.1 21.98 37.4 21.98 37.4 22.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.37 22.46 40.06 22.46 40.06 21.45 39.88 21.45 39.88 22.46 39.57 22.46 39.57 21.45 39.39 21.45 39.39 21.98 38.41 21.98 38.41 22.64 39.11 22.64 39.11 22.46 38.59 22.46 38.59 22.15 39.39 22.15 39.39 22.64 40.55 22.64 40.55 21.45 40.37 21.45 40.37 22.46"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.93,
    y: 21.49,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.42,
    y: 22.47,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.29 9.47 42.82 9.47 42.82 9.78 42.01 9.78 42.01 9.29 40.86 9.29 40.86 9.99 41.03 9.99 41.03 9.47 41.84 9.47 41.84 9.96 42.99 9.96 42.99 9.29 42.29 9.29 42.29 9.47"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.31,
    y: 9.78,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.83,
    y: 8.8,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "43.31 9.96 44.01 9.96 44.01 9.78 43.48 9.78 43.48 9.47 44.28 9.47 44.28 9.96 45.44 9.96 45.44 8.77 45.26 8.77 45.26 9.78 44.95 9.78 44.95 8.77 44.77 8.77 44.77 9.78 44.46 9.78 44.46 8.77 44.28 8.77 44.28 9.29 43.31 9.29 43.31 9.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "43.27 10.39 43.27 10.48 43.27 10.57 45.47 10.57 45.47 10.48 45.47 10.39 43.27 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.83 10.39 40.83 10.48 40.83 10.57 43.03 10.57 43.03 10.48 43.03 10.39 40.83 10.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "43.27 20.88 43.27 20.96 43.27 21.05 45.47 21.05 45.47 20.96 45.47 20.88 43.27 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "40.83 20.88 40.83 20.96 40.83 21.05 43.03 21.05 43.03 20.96 43.03 20.88 40.83 20.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.26 22.46 44.95 22.46 44.95 21.45 44.77 21.45 44.77 22.46 44.46 22.46 44.46 21.45 44.28 21.45 44.28 21.98 43.31 21.98 43.31 22.64 44.01 22.64 44.01 22.46 43.48 22.46 43.48 22.15 44.28 22.15 44.28 22.64 45.44 22.64 45.44 21.45 45.26 21.45 45.26 22.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.29 22.15 42.82 22.15 42.82 22.46 42.01 22.46 42.01 21.98 40.86 21.98 40.86 22.68 41.03 22.68 41.03 22.15 41.84 22.15 41.84 22.64 42.99 22.64 42.99 21.98 42.29 21.98 42.29 22.15"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 40.83,
    y: 21.49,
    width: 3.18,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 41.31,
    y: 22.47,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "46.9 9.29 45.75 9.29 45.75 9.99 45.93 9.99 45.93 9.47 46.73 9.47 46.73 9.96 47.17 9.96 47.17 9.78 46.9 9.78 46.9 9.29"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.72,
    y: 8.8,
    width: 1.45,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.21,
    y: 9.78,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.72 10.48 45.72 10.57 47.17 10.57 47.17 10.39 45.72 10.39 45.72 10.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.72 20.96 45.72 21.05 47.17 21.05 47.17 20.88 45.72 20.88 45.72 20.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "46.9 21.98 45.75 21.98 45.75 22.68 45.93 22.68 45.93 22.15 46.73 22.15 46.73 22.64 47.17 22.64 47.17 22.46 46.9 22.46 46.9 21.98"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.21,
    y: 22.47,
    width: 0.24,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 45.72,
    y: 21.49,
    width: 1.45,
    height: 0.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23,18.78a4.21,4.21,0,0,1-1.54.23,3.62,3.62,0,0,0,1.84.1v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.2,18.78a3.58,3.58,0,0,0,.67-5.9,3.93,3.93,0,0,1-.94,5.38l0,.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26,18.31h0a3,3,0,0,0,1.1-4.1,3,3,0,0,0-1.87-1.41A3.93,3.93,0,0,1,26,18.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.58,19.65l.31-.42v-.12L23.61,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.64,18.52l.27.14,0-.4.12-2.93V13a1.28,1.28,0,0,1-.47-.39l.2,3.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.58,12.46a.57.57,0,0,0,.79.13.55.55,0,0,0,.2-.67.53.53,0,0,1-.62.43.56.56,0,0,1-.37-.26l.08.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.22,16.71A3.58,3.58,0,0,0,23,18.78l.29.13,0-.65a3.93,3.93,0,0,1-.95-5.38A3.6,3.6,0,0,0,21.22,16.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.64,18.52l0,.52.28.07a3.65,3.65,0,0,0,1.85-.1,4.21,4.21,0,0,1-1.54-.23l-.29-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.15,18.32h0a3.92,3.92,0,0,1,.78-5.5,3,3,0,0,0-.78,5.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.26,18.91v.32l.3.42,0-.61,0-.52.14-2.8-.2-3.09a1.33,1.33,0,0,1-.46.39v2.31l.12,2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.79,12.59a.57.57,0,0,0,.79-.13l.08-.08-.08-.29a.54.54,0,0,1-.36.26.55.55,0,0,1-.63-.43A.58.58,0,0,0,22.79,12.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIran);
export default __webpack_public_path__ + "static/media/iran.f33f08bb8b78e919d4122470c4297dc6.svg";
export { ForwardRef as ReactComponent };